import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  NavLink,
  withRouter,
} from "react-router-dom";
import Products from './index';
import * as ROUTERS from '../../../../constants/routes';


const ProductsRoute = (props) => {
   
    const categories = useSelector(state => state.shops.categories);
    const categoriesData = Array.isArray(categories)
        ? [...categories]
        : Object.values(categories || {});
    const firstCategory = categoriesData
        .sort((a, b) => (a.order || 0) - (b.order || 0))[0]?.id;
    const { history, location } = props;

    useEffect(() => {
            if(firstCategory){
                history.push(`/page/menu/products/sort-mode/products/category/${firstCategory}`);  
            }
    }, []);


    return (
    <>
         <div></div>
      </>
    )
}


export default withRouter(ProductsRoute);
